
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 3a1 1 0 011-1h14a1 1 0 110 2v.578a8 8 0 01-1.344 4.437L15.666 12l1.99 2.985A8 8 0 0119 19.422V20a1 1 0 110 2H5a1 1 0 110-2v-.578a8 8 0 011.344-4.437L8.334 12l-1.99-2.985A8 8 0 015 4.578V4a1 1 0 01-1-1zm3 17h1.25l1.63-2.608c.98-1.567 3.26-1.567 4.24 0L15.75 20H17v-.578a6 6 0 00-1.008-3.328L13.93 13h-3.86l-2.062 3.094A6 6 0 007 19.422V20zM7 4h10v.578A6 6 0 0116.49 7H7.51A6 6 0 017 4.578V4z"}})])
          )
        }
      }
    